import { createAction, props } from '@ngrx/store';
import {
  ProjectJobServiceCreateResponseJson,
  ProjectPermitTaskServiceCreateResponseJson,
  ProjectServiceCreateResponseJson,
  ProjectSurveyTaskServiceCreateResponseJson,
} from '@vmspdb/definitions';

export const clearProjectDetails = createAction(
  '[ProjectDetails] Clear ProjectDetails',
);

export const loadProjectDetails = createAction(
  '[ProjectDetails] Load ProjectDetails',
  props<{ uuid: string }>(),
);

export const loadProjectDetailsSuccess = createAction(
  '[ProjectDetails] Load ProjectDetails Success',
  props<{ data: ProjectServiceCreateResponseJson }>(),
);

export const loadProjectDetailsFailure = createAction(
  '[ProjectDetails] Load ProjectDetails Failure',
  props<{ error: any }>(),
);

// Jobs
export const loadProjectDetailsJobs = createAction(
  '[ProjectDetails] Load ProjectDetails Jobs',
  props<{ uuid: string }>(),
);

export const loadProjectDetailsJobsSuccess = createAction(
  '[ProjectDetails] Load ProjectDetails Jobs Success',
  props<{ data: ProjectJobServiceCreateResponseJson[] }>(),
);

export const loadProjectDetailsJobsFailure = createAction(
  '[ProjectDetails] Load ProjectDetails Jobs Failure',
  props<{ error: any }>(),
);

// Permits
export const loadProjectDetailsPermits = createAction(
  '[ProjectDetails] Load ProjectDetails Permits',
  props<{ uuid: string }>(),
);

export const loadProjectDetailsPermitsSuccess = createAction(
  '[ProjectDetails] Load ProjectDetails Permits Success',
  props<{
    data: ProjectPermitTaskServiceCreateResponseJson[];
  }>(),
);

export const loadProjectDetailsPermitsFailure = createAction(
  '[ProjectDetails] Load ProjectDetails Permits Failure',
  props<{ error: any }>(),
);

// Surveys
export const loadProjectDetailsSurveys = createAction(
  '[ProjectDetails] Load ProjectDetails Surveys',
  props<{ uuid: string }>(),
);

export const loadProjectDetailsSurveysSuccess = createAction(
  '[ProjectDetails] Load ProjectDetails Surveys Success',
  props<{
    data: ProjectSurveyTaskServiceCreateResponseJson[];
  }>(),
);

export const loadProjectDetailsSurveysFailure = createAction(
  '[ProjectDetails] Load ProjectDetails Surveys Failure',
  props<{ error: any }>(),
);
